import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=61737d1e&scoped=true"
var script = {}
import style0 from "./Header.vue?vue&type=style&index=0&id=61737d1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61737d1e",
  null
  
)

export default component.exports